import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { SBPayments } from 'sb-payments-editec';
import { paymentProviders } from 'paymentActions.js';
import { translation } from 'helpers/utilsHelper.js';
import { providerSettingsSelector } from 'paymentsSelector.js';
import Loader from 'Loader.js';
import S from 'StyledAccountDeposit.js';
import { setSessionCookie } from 'cookiesHelper.js'
import {loginCustomerByCookie} from 'authActions.js';
import {loadCustomerData} from 'customerActions.js';

const { Payments, useSession } = SBPayments;

const AccountDeposit = ({ dispatch, brandData, providers, isPending, loginCustomerByCookie, loadCustomerData }) => {
  const { deposits } = providers ?? {};
  const { brandId, mainCurrency, countryCode, mobilePrefix } = brandData ?? {};

  const retrieveProviders = async () => {
    try {
      if (mainCurrency) {
        await dispatch(paymentProviders(mainCurrency));
      } else {
        await dispatch(paymentProviders());
      }
    } catch (error) {
      console.log('paymentProviders error:' + error);
    }
  };

  const getLang = () => {
    return `lang_${app.config.lang.toLowerCase()}_${countryCode.toLowerCase()}_${brandId}_1`;
  };

  const getRequestLanguage = () => {
    const lang = Cookies.get('Language');
    return lang || app.config.lang
  }

  const loginIWGUserAfterFirstDeposit = async (sessionId) => {
    setSessionCookie(sessionId)
    try {
      await loginCustomerByCookie();
    } catch (error) {
      throw error
    }
  }

  const refreshCustomerBalance = () => {
    loadCustomerData();
  }

  const paymentsProps = {
    session: useSession(),
    lang: getLang(),
    currencyCode: mainCurrency,
    countryCode: countryCode,
    brandId,
    mobilePrefix,
    loginUser: loginIWGUserAfterFirstDeposit,
    requestLanguage: getRequestLanguage(),
    useCaptcha: app.config.useTurnstileCaptcha.useTurnstileCaptchaForIWG,
    refreshCustomerBalance: refreshCustomerBalance
  };

  useEffect(() => {
    retrieveProviders();
  }, []);

  if (isPending) return <Loader />;

  return deposits?.length ? <Payments {...paymentsProps} /> : <S.NoActiveProviders>{translation('payments_noActiveProviders')}</S.NoActiveProviders>;
};

const mapStateToProps = (state, props) => {
  const {
    Auth: { brandData },
    AccountDeposit: { isPending },
  } = state;
  const providers = providerSettingsSelector(state, props);

  return {
    brandData,
    providers,
    isPending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      loginCustomerByCookie: bindActionCreators(loginCustomerByCookie, dispatch),
      loadCustomerData: bindActionCreators(loadCustomerData, dispatch),
      dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountDeposit);
